module.exports = __webpack_public_path__ + "img/cart.da927c14.png";